// src/components/WhatsAppButton.jsx
export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/918319789552"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-600 text-white p-4 rounded-full shadow-lg hover:bg-green-700 transition"
      title="Chat on WhatsApp"
    >
      <svg
        className="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 32 32"
      >
        <path d="M16 0C7.164 0 0 6.96 0 15.556c0 2.741.757 5.364 2.193 7.684L0 32l9.077-2.532c2.062.567 4.195.854 6.329.854 8.836 0 16-6.96 16-15.556S24.836 0 16 0zm0 28.444c-1.861 0-3.715-.273-5.49-.812l-.393-.117-5.366 1.498 1.44-5.243-.253-.39c-1.313-2.025-2.007-4.369-2.007-6.824 0-6.867 5.735-12.456 12.77-12.456 7.033 0 12.768 5.589 12.768 12.456 0 6.867-5.735 12.456-12.77 12.456zm7.261-8.82c-.4-.2-2.365-1.167-2.732-1.3-.367-.134-.633-.2-.9.2-.267.4-1.034 1.3-1.267 1.566-.233.267-.467.3-.867.1-.4-.2-1.7-.634-3.236-2.017-1.196-1.068-2.004-2.384-2.238-2.784-.233-.4-.025-.616.175-.816.179-.178.4-.467.6-.7.2-.233.267-.4.4-.667.134-.267.067-.5 0-.7-.067-.2-.6-1.6-.825-2.178-.217-.567-.442-.5-.6-.5-.15 0-.333-.017-.516-.017-.183 0-.483.067-.733.333s-.967 1-.967 2.367 1 2.75 1.15 2.933c.15.183 1.967 3.017 4.783 4.234.667.3 1.184.483 1.584.617.667.217 1.275.184 1.75.117.534-.083 1.634-.667 1.867-1.316.233-.65.233-1.2.167-1.317-.066-.116-.217-.183-.45-.3z" />
      </svg>
    </a>
  );
}
